/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * Page: Not Found Page.
 */

import React from "react";
import { PageLayout } from "../components/PageLayout";

export const NotFoundPage = () => {
  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Not Found
        </h1>
      </div>
    </PageLayout>
  );
};
